import React from 'react'
import { connect } from 'react-redux'
import { setEmailSenderModule } from 'state/actions'
import EmailSender from './'
import nesProp from 'nested-property'
import styles from './emailSenderModal.scss'
import cs from 'classnames'
import underscore from 'underscore'
import i18n from 'lib/i18n'
import c from 'state/constants'

// variables out of module
const _ = i18n('emailSender')

/**
 * This module render a button witch can be used to open a mail sender modal.
 */
@connect(
    state => ({
        moduleKey: state.emailSender.moduleKey,
        modalIdOpened: state.emailSender.modalIdOpened,
        EmailTemplateRelations: state.app.security.EmailTemplateRelations,
        initialArgumentsFromStore: state.clients.initialArguments
    })
)
export default class EmailButton extends React.Component {
    static propTypes = {
        moduleKeyToSet: React.PropTypes.string.isRequired,
        moduleOptions: React.PropTypes.object,
        initialArguments: React.PropTypes.any,
        customButtonLabel: React.PropTypes.string,
        customClassName: React.PropTypes.string,
        isWhiteIcon: React.PropTypes.bool,
        // used to recognise the current modal if there is more emailer button on the page.
        // without this you cant open/close them separately, because are driven by store
        modalId: React.PropTypes.string,
        onInit: React.PropTypes.func,
        onSent: React.PropTypes.func,
        onSentLate: React.PropTypes.func, // after hitting ok on confirmation button
        hideCC: React.PropTypes.bool,
        multiLanguage: React.PropTypes.bool,
        serialSending: React.PropTypes.bool,
        getDSStakeholders: React.PropTypes.func,
        isCreatable: React.PropTypes.bool,
        forceIsMulti: React.PropTypes.bool,
        forceOpen: React.PropTypes.bool,
        onCancel: React.PropTypes.func,
        hideButton: React.PropTypes.bool,
        noLabel: React.PropTypes.bool,
    }

    constructor(props) {
        super(props)
        this.state = { buttonLabel: "", customClassName: props.customClassName }
    }

    /**
     * This function fired when the module attached
     */
    componentDidMount() {
        // decide auto open
        let autoEmailModalOpen = this.getAutoOpen(this.props)

        if (autoEmailModalOpen) {
            this.openEmailModal()
        }

        // get label for button
        let buttonLabel = this.getButtonLabel(this.props)
        let customClassName = this.props.customClassName ? this.props.customClassName : cs(styles.grayButton, styles.emailButton)

        this.setState({ buttonLabel, customClassName })

        // must be a function but optional, do not check if it is a function, to get error in case someone use it wrongly
        if (this.props.onInit) {
            let result = this.props.onInit()
        }
    }

    componentWillReceiveProps(nextProps) {
        let buttonLabel = this.getButtonLabel(nextProps)

        this.setState({ buttonLabel })
    }

    /**
     *
     * @param {*} props
     * @returns
     */
    getButtonLabel(props) {
        const clientsProfileKey = nesProp.get(props, "EmailTemplateRelations.EmailTemplateModules.clientsProfile.value")
        // decide label by module
        let buttonLabel = (props.moduleKeyToSet == clientsProfileKey) ? _('sendEmailOffer') : _('sendEmail')

        // decide label by customization parameter
        buttonLabel = props.customButtonLabel ? props.customButtonLabel : buttonLabel

        return buttonLabel
    }

    /**
     *
     * for further operation
     * @param {*} props
     * @returns
     */
    getAutoOpen(props) {
        const { initialArguments, initialArgumentsFromStore } = props

        // decide to open the emailer automated or not
        let autoEmailModalOpen = false

        let initArgs = initialArguments || initialArgumentsFromStore

        if (initArgs) {
            autoEmailModalOpen = initArgs.autoEmailModalOpen || false
        }

        return autoEmailModalOpen
    }

    /**
     * This function helps to use an icon on a safe way
     */

    getIcon = (menuName, isWhite = false) => {
        try {
            return isWhite ? require(`resources/images/m-${menuName}.svg`) : require(`resources/images/icn-${menuName}-white.svg`)
        } catch (err) {
            console.log(err);

            return require(`resources/images/icn-no-result.svg`)
        }
    }

    /**
     * This function will open a modal for sending email contains the associated template.
     */
    async openEmailModal() {
        const { dispatch, moduleKeyToSet, modalId, isInvitation, packageStatusCheck } = this.props
        if (isInvitation && packageStatusCheck) {
            const canOpenInvitationModal = await packageStatusCheck()
            if (!canOpenInvitationModal) {
                return
            }
        }
        // set the moduleKey to trigger the email sender modal with the correct templates
        dispatch(setEmailSenderModule(moduleKeyToSet, modalId))
    }

    /**
     * Main render function
     */
    render() {
        const { moduleKey, moduleOptions, isWhiteIcon, modalIdOpened, hideButton,
            initialArgumentsFromStore, initialArguments, noLabel } = this.props
        const { buttonLabel, customClassName } = this.state

        let modalId = this.props.modalId ? this.props.modalId : ""

        // set module options extras from initial arguments
        if (initialArgumentsFromStore && Object.keys(initialArgumentsFromStore).length > 0) {
            moduleOptions.autoSelectTemplate = moduleOptions.autoSelectTemplate || initialArgumentsFromStore.autoSelectTemplate ? true : false
            moduleOptions.startedFromModule = initialArgumentsFromStore.startedFromModule || null
            moduleOptions.quickReply = initialArgumentsFromStore.quickReply ? true : false
            moduleOptions.ticketId = initialArgumentsFromStore.ticketId || ''
        }

        return (
            <div key={"emailSenderButtonContainer_" + modalId}>
                {!hideButton &&
                    <div
                        key={"btnSendMail_" + modalId}
                        className={customClassName}
                        onClick={(e) => {
                            e.preventDefault()
                            this.openEmailModal()
                        }}
                    >
                        <div className={styles.iconTextOrganizer}>
                            <div className={styles.buttonIcon} key={"emailSenderButtonContainer_iconTextOrganizerbuttonIcon"}>
                                <img className={cs(noLabel ? styles.emailButtonNoLabelIcon : styles.emailButtonIcon)} src={noLabel ? this.getIcon('inbox-blue', isWhiteIcon) : this.getIcon('inbox', isWhiteIcon)} />
                            </div>
                            {!noLabel &&
                                <div className={styles.buttonText} key={"emailSenderButtonContainer_iconTextOrganizerbuttonText"}>
                                    {buttonLabel}
                                </div>
                            }
                        </div>

                    </div>}
                {moduleKey && (modalIdOpened === modalId || (!modalIdOpened && !modalId)) &&
                    <EmailSender
                        moduleOptions={moduleOptions}
                        modalId={modalId}
                        onSent={this.props.onSent}
                        onSentLate={this.props.onSentLate}
                        hideCC={this.props.hideCC}
                        multiLanguage={this.props.multiLanguage}
                        serialSending={this.props.serialSending}
                        getDSStakeholders={this.props.getDSStakeholders}
                        isCreatable={this.props.isCreatable}
                        forceIsMulti={this.props.forceIsMulti}
                        onCancel={this.props.onCancel}
                        forceOpen={this.props.forceOpen}
                        key={"emailSenderButtonContainer_EmailSender_integrated"}
                    />
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/emailSender/emailButton.jsx